<div class="my-2">
  <div class="mb-2 flex justify-between">
    <h1 class="text-lg font-bold">{{ title }}</h1>
    <a
      class="btn btn-ghost btn-xs text-sm text-slate-400"
      [routerLink]="['products']"
      [queryParams]="{ type: queryType }">
      Xem thêm
    </a>
  </div>
  <div class="bg-white px-1 py-2">
    <section class="splide" #splide>
      <div class="splide__track">
        <ul class="splide__list">
          <li class="splide__slide">
            <div
              class="cursor-pointer overflow-hidden rounded bg-primary-content p-2">
              <market-carousel-product-item-skeleton />
            </div>
          </li>
          <li class="splide__slide">
            <div
              class="cursor-pointer overflow-hidden rounded bg-primary-content p-2">
              <market-carousel-product-item-skeleton />
            </div>
          </li>
          <li class="splide__slide">
            <div
              class="cursor-pointer overflow-hidden rounded bg-primary-content p-2">
              <market-carousel-product-item-skeleton />
            </div>
          </li>
          <li class="splide__slide">
            <div
              class="cursor-pointer overflow-hidden rounded bg-primary-content p-2">
              <market-carousel-product-item-skeleton />
            </div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</div>
